module.exports = __webpack_public_path__ + "static/media/Peito.72d51379.png";